export class ItineraryEntry {
  constructor(options?: {title: string; subtitle?: string; mobileSubtitle?: string; start?: string; mid?: string; dest?: string;}) {

      if (options) {
          this.title = options.title;
          this.subtitle = options.subtitle;
          this.mobileSubtitle = options.mobileSubtitle;
          this.start = options.start;
          this.mid = options.mid;
          this.dest = options.dest;
      } else {
        this.mobileSubtitle = '';
      }
      this.isOpened = false;
  }
  title: string; // Ex: "Day 1"
  subtitle: string; // Ex: "Serengeti Safari"
    start: string;
    mid: string;
    dest: string;
  mobileSubtitle: string; // Ex: "SUMMIT"

  // if the accordion entry is opened or closed
  isOpened: boolean;

  // lookup ID for the itinerary entry
  contentId: string;
}

export class ItinerarySettings {
  constructor(options?: {entries: ItineraryEntry[]; truncateHeader: boolean; }) {
      if (options) {
          this.entries = options.entries;
          this.truncateHeader = options.truncateHeader;

          for (const entryIdx of Object.keys(this.entries)) {
            this.entries[entryIdx].contentId = 'entry' + entryIdx;
          }
      }
  }

  // the array of itinerary entries and their respective metadatas
  entries: ItineraryEntry[];

  // truncate the header with ellipsis
  truncateHeader: boolean;
}
